import {Component, OnInit, ViewChild} from '@angular/core';

@Component({
    selector: 'page-not-access-swal',
    templateUrl: './page-not-access-swal.component.html',
    styleUrls: ['./page-not-access-swal.component.scss']
})
export class PageNotAccessSwalComponent implements OnInit {

    @ViewChild('swalModalNotAccess') swalModalNotAccess: any;

    constructor() {
    }

    ngOnInit() {
    }

    showModal() {
        this.swalModalNotAccess.show();
    }
}



// WEBPACK FOOTER //
// /app/src/app/page-not-access-swal/page-not-access-swal.component.ts